/**
 * ScreenCheck Portal API
 * ScreenCheck Portal REST API
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The ReportsResponse model module.
 * @module model/ReportsResponse
 * @version 0.0.1
 */
class ReportsResponse {
    /**
     * Constructs a new <code>ReportsResponse</code>.
     * @alias module:model/ReportsResponse
     */
    constructor() { 
        
        ReportsResponse.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>ReportsResponse</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/ReportsResponse} obj Optional instance to populate.
     * @return {module:model/ReportsResponse} The populated <code>ReportsResponse</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new ReportsResponse();

            if (data.hasOwnProperty('reports')) {
                obj['reports'] = ApiClient.convertToType(data['reports'], [Object]);
            }
            if (data.hasOwnProperty('totalRows')) {
                obj['totalRows'] = ApiClient.convertToType(data['totalRows'], 'Number');
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>ReportsResponse</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>ReportsResponse</code>.
     */
    static validateJSON(data) {
        // ensure the json data is an array
        if (!Array.isArray(data['reports'])) {
            throw new Error("Expected the field `reports` to be an array in the JSON data but got " + data['reports']);
        }

        return true;
    }


}



/**
 * @member {Array.<Object>} reports
 */
ReportsResponse.prototype['reports'] = undefined;

/**
 * @member {Number} totalRows
 */
ReportsResponse.prototype['totalRows'] = undefined;






export default ReportsResponse;

